/* Modal sizing - matches the management-app implementation exactly */
.modalRoot {
  height: 80vh;
  width: 80vw;
  max-width: 80vw;
  max-height: 80vh;
}

/* Root container with Stack-like layout (gap: 2 = 16px, padding: 2 = 16px) */
.root {
  display: flex;
  flex-direction: column;
  gap: 16px;
  height: 100%;
  padding: 16px;
  box-sizing: border-box;
}

/* Optional title styling */
.title {
  margin: 0;
  font-family: var(--font-bold, inherit);
  font-size: 18px;
  color: var(--black, #000);
}

/* Editor container fills remaining space */
.editorContainer {
  flex: 1;
  min-height: 0;
  overflow: hidden;
}

/* Ensure the MDEditor fills its container */
.editorContainer :global(.w-md-editor) {
  height: 100% !important;
}

.editorContainer :global(.w-md-editor-content) {
  height: calc(100% - 29px) !important;
}

/* Buttons container - matches MUI styled div with gap: 10px */
.buttons {
  display: flex;
  gap: 10px;
  flex-shrink: 0;
}

/* Base button styles */
.button {
  box-sizing: border-box;
  min-width: 64px;
  padding: 6px 16px;
  border-radius: 4px;
  border: none;
  font-family: var(--font-semibold, "Roboto", "Helvetica", "Arial", sans-serif);
  font-size: 14px;
  font-weight: 500;
  line-height: 1.75;
  letter-spacing: 0.02857em;
  text-transform: uppercase;
  cursor: pointer;
  transition: background-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
              box-shadow 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
              border-color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,
              color 250ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Primary button (Save) - MUI primary color */
.buttonPrimary {
  background-color: #1976d2;
  color: #fff;
}

.buttonPrimary:hover {
  background-color: #1565c0;
}

.buttonPrimary:disabled {
  background-color: rgba(0, 0, 0, 0.12);
  color: rgba(0, 0, 0, 0.26);
  cursor: not-allowed;
}

/* Secondary button (Cancel) - MUI secondary color */
.buttonSecondary {
  background-color: #9c27b0;
  color: #fff;
}

.buttonSecondary:hover {
  background-color: #7b1fa2;
}

/* Loading spinner for save button */
.loadingSpinner {
  width: 16px;
  height: 16px;
  border: 2px solid transparent;
  border-top-color: currentColor;
  border-radius: 50%;
  animation: spin 0.8s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

/* Responsive adjustments for smaller screens */
@media (max-width: 600px) {
  .modalRoot {
    height: 95vh;
    width: 95vw;
    max-width: 95vw;
    max-height: 95vh;
  }

  .root {
    padding: 12px;
    gap: 12px;
  }

  .buttons {
    flex-direction: column;
  }

  .button {
    width: 100%;
  }
}
